import {SettingTargetComponent} from "./setting-target.component";

export default SettingTargetComponent